import jwtDecode from 'jwt-decode';
import moment from 'moment';
import Axios from 'axios';
import he from 'he';
import MyStorage from '../../constants/myStorage';
import store from '../../store';
import API from '../../config/api';
import { applyMagic } from '../../containers/Login/styles';
import firestore from '@react-native-firebase/firestore';

async function purgePersitor() {
	try {
		localStorage.clear();
	} catch (error) {
		console.warn(error);
	}
	await store.persistor.purge();
}

function setToken(token) {
	try {
		localStorage.setItem(MyStorage.TOKEN, token);
	} catch (error) {
		console.warn(error);
	}
}

function getToken() {
	try {
		const token = localStorage.getItem(MyStorage.TOKEN);
		return token;
	} catch (error) {
		console.warn(error);
		return null;
	}
}

function getRefreshToken() {
	try {
		const token = localStorage.getItem(MyStorage.REFRESH);
		return token;
	} catch (error) {
		console.warn(error);
		return null;
	}
}

function setRefreshToken(token) {
	try {
		localStorage.setItem(MyStorage.REFRESH, token);
	} catch (error) {
		console.warn(error);
	}
}

function purgeTokens() {
	try {
		localStorage.removeItem(MyStorage.TOKEN);
		localStorage.removeItem(MyStorage.REFRESH);
	} catch (error) {
		console.warn(error);
	}
}

async function logoutFromAPI(history) {
	await purgePersitor();
	const token = await getToken();
	const refresh = await getRefreshToken();
	//console.log(token, refresh, "refresh")
	// history.push("/")
	if (token) {
		const url = `${API()}/action/logout`;
		const options = {
			url,
			params: {
				ajax: true,
				token: refresh,
			},
		};
		Axios(options).then((res) => {
			//console.log(res.data, "res")
			// history.push("/")
		}).catch((err) => {
			//console.log(err) 
		});
	}
	purgeTokens();
	history.push("/")
	await purgeImages();
	await purgePdf();
}

async function logout() {

	await purgePersitor();
	const token = await getToken();
	const refresh = await getRefreshToken();
	//console.log(token, refresh, "refresh")
	// history.push("/")
	if (token) {
		const url = `${API()}/action/logout`;
		const options = {
			url,
			params: {
				ajax: true,
				token: refresh,
			},
		};
		Axios(options).then((res) => {
			//console.log(res.data, "res")
			// history.push("/")
		}).catch((err) => {
			//console.log(err) 
		});
	}
	purgeTokens();
	history.push("/")
	await purgeImages();
	await purgePdf();
	// const token = await getToken();
	// const refresh = await getRefreshToken();
	// if (token) {
	// 	const url = `${API()}/action/logout`;
	// 	const options = {
	// 		url,
	// 		params: {
	// 			ajax: true,
	// 			token: refresh,
	// 		},
	// 	};
	// 	Axios(options);
	// }
	// await purgeTokens();
	// purgePersitor();
}

async function isTokenExpired() {
	try {
		const token = await getToken();
		const { exp } = jwtDecode(token);

		return exp * 1000 < +moment();
	} catch (error) {
		console.warn(error);
		return true;
	}
}

async function checkToken() {
	try {
		const token = await getToken();
		if (token) {
			if (await isTokenExpired()) {
				logout();
			}
		} else {
			logout();
		}
	} catch (error) {
		console.warn(error);
	}
}

async function setUser(user) {
	/* //console.log({
		email: user.email,
		id: user.id,
		username: he.decode(`${user.firstName} ${user.lastName}`),
		role: user.addInfo1,
		termsAndConditions: user.addInfo2,
		locations: user.addInfo4,
		personIdOfCreator: user.addInfo6,
	}); */

	try {
		localStorage.setItem(MyStorage.USER, JSON.stringify(user));

		const documentSnapshot = await firestore()
			.collection(`users/${user?.email}/pin`)
			.doc("buttons") // Specify the document ID
			.get();

		if (documentSnapshot._exists) {
			const data = {
				id: documentSnapshot.id,
				...documentSnapshot.data()
			};
			if (data?.pinButtons) {
				localStorage.setItem('pinButtons', JSON.stringify(data?.pinButtons));
			}
			console.log(data); // Use the data as needed
		} else {
			console.log("No such document!");
		}

		const globalConfig = await firestore()
			.collection(`Config`)
			.doc("Checklist") // Specify the document ID
			.get();
		console.log(globalConfig, "globalConfig");
		
		if (globalConfig._exists) {
			const data = {
				id: globalConfig.id,
				...globalConfig.data()
			};
			if (data) {
				console.log(data,"data");
				localStorage.setItem('globalConfig', JSON.stringify(data));
			}
			console.log(data); // Use the data as needed
		} else {
			console.log("No such document!");
		}
	} catch (error) {
		console.warn(error);
	}
}


async function getGlobalConfig() {
	try {
		const config = localStorage.getItem('globalConfig');
		return JSON.parse(config);
	} catch (error) {
		console.warn(error);
		return null;
	}
}

function getUser() {
	try {
		const user = localStorage.getItem(MyStorage.USER);
		return JSON.parse(user);
	} catch (error) {
		console.warn(error);
		return null;
	}
}

function setPushToken(token) {
	try {
		localStorage.setItem(MyStorage.MESSAGE_TOKEN, token);
	} catch (error) {
		console.warn(error);
	}
}

function getPushToken() {
	try {
		const token = localStorage.getItem(MyStorage.MESSAGE_TOKEN);
		return token;
	} catch (error) {
		console.warn(error);
		return null;
	}
}

function setCreds(creds) {
	// dont keep password on webversion
	const newCreds = creds;
	newCreds.password = applyMagic(newCreds.password)
	// delete newCreds.password;
	try {
		localStorage.setItem(MyStorage.CREDS, JSON.stringify(newCreds));
	} catch (error) {
		console.warn(error);
	}
}
function getCreds() {
	try {
		const creds = localStorage.getItem(MyStorage.CREDS);
		return JSON.parse(creds);
	} catch (error) {
		console.warn(error);
		return null;
	}
}

async function init(tokens) {
	await setToken(tokens.access);
	await setRefreshToken(tokens.refresh);
	const { personId, userId } = jwtDecode(tokens.access);
	const user = { personId, userId };
	await setUser(user);
}

export default {
	setToken,
	setRefreshToken,
	logout,
	logoutFromAPI,
	isTokenExpired,
	checkToken,
	setUser,
	getUser,
	getToken,
	getRefreshToken,
	getGlobalConfig,
	setCreds,
	getCreds,
	setPushToken,
	getPushToken,
	purgeTokens,
	init,
};
